import React from 'react';
import { FormattedMessage } from 'react-intl';
const NotAvailableFlight = ({
  isMobileDevice,
  hasFilter = false,
  message = '',
}) => {
  return (
    <div className="col d-flex p-0 flex-column my-5">
      <div
        className={`w-100 d-flex px-1 justify-content-center align-items-center text-danger font-weight-bold font-md-xxlarge font-small`}
      >
        <span
          className={`text-center ${
            isMobileDevice ? 'text-wrap w-75 font-small' : ''
          }`}
        >
          <FormattedMessage
            id={`${
              message
                ? message
                : hasFilter
                ? 'booking.noresultwithfilter'
                : 'booking.noavailableflight'
            }`}
            defaultMessage={`${
              message
                ? message
                : hasFilter
                ? 'booking.noresultwithfilter'
                : 'booking.noavailableflight'
            }`}
          />
        </span>
      </div>

      <div className="justify-content-center align-items-center w-100 d-flex py-3">
        <img
          className="img-fluid"
          src={require('../../../../content/images/icon/flight-not-found.png')}
          alt=""
        />
      </div>
    </div>
  );
};
export default NotAvailableFlight;
